module.exports = __webpack_public_path__ + "img/15-2.229cc18b.png";